const singleRoomLongTermPriceWrapper = document.querySelector('.single-room-long-price');
if (singleRoomLongTermPriceWrapper) {

    const url =  window.location.search;
    const urlParams = new URLSearchParams(url);

    const season = urlParams.get('season');
    const room_id = urlParams.get('room_id');
    const term = urlParams.get('term');


    const data = new FormData();
    data.append('action', 'get_room_data');
    data.append('season', season);
    data.append('roomId', room_id);
    data.append('post_id', ajaxObject.post_id)
    data.append('nonce', ajaxObject.nonce);

    fetchRoomData(data, singleRoomLongTermPriceWrapper);
}


const singleRoomShortTermPriceWrapper = document.querySelector('.single-room-short-price');
if (singleRoomShortTermPriceWrapper) {

    const url =  window.location.search;
    const urlParams = new URLSearchParams(url);

    const date_from = urlParams.get('date_from');
    const date_to = urlParams.get('date_to');
    const room_id = urlParams.get('room_id');
    // const term = urlParams.get('term');


    const data = new FormData();
    data.append('action', 'get_room_data_short');
    // data.append('roomId', room_id);
    // data.append('date_from', date_from);
    // data.append('date_to', date_to);
    if (room_id !== null && room_id !== undefined) {
        data.append('roomId', room_id);
    }
    if (date_from !== null && date_from !== undefined) {
        data.append('date_from', date_from);
    }
    if (date_to !== null && date_to !== undefined) {
        data.append('date_to', date_to);
    }
    data.append('post_id', ajaxObject.post_id)
    data.append('nonce', ajaxObject.nonce);

    fetchRoomData(data, singleRoomShortTermPriceWrapper);
}






function fetchRoomData(data, priceElement){
    fetch(ajaxObject.ajax_url, {
        method: "POST",
        // credentials: 'same-origin',
        body: data
    })
        .then(response => {
            if (!response.ok) {
                throw new Error(`[${response.status}] ${response.statusText}`);
            }
            return response.json();
        })
        .then(response => {
            console.log(response)
            priceElement.innerHTML = response.data.html;


        })
        .catch(error => {
            console.error(error);
        });
}